{
    "Profile_LiabilityExposures.title": "Liability Exposures",
    "Profile_LiabilityExposures.multipleLocations": "Do you own/rent more than one location?",
    "Profile_LiabilityExposures.weeksLocationRented": "Number of weeks location rented to others?",
    "Profile_LiabilityExposures.roomsRented": "Number of rooms rented to others?",
    "Profile_LiabilityExposures.daycareChildren": "Daycare operation - number of children",
    "Profile_LiabilityExposures.trampoline": "Do you own a trampoline?",
    "Profile_LiabilityExposures.gardenTractor": "Do you have a garden tractor?",
    "Profile_LiabilityExposures.golfCart": "Do you have a golf cart?",
    "Profile_LiabilityExposures.saddleAnimals": "Number of saddle/draft animals?",
    "Profile_LiabilityExposures.recreationalVehicles": "Do you own any unlicensed recreational vehicles?",
    "Profile_LiabilityExposures.renewableEnergy": "Renewable energy installation on premises?",
    "Profile_LiabilityExposures.watercrafts": "Do you own any watercrafts?",
    "Profile_LiabilityExposures.fullTimeEmployees": "Number of full time residence employees?",
    "Profile_LiabilityExposures.coOccupant": "Is there a co-occupant that requires coverage?",
    "Profile_LiabilityExposures.coOccupantName": "Co-occupant name",
    "Profile_LiabilityExposures.businessOperation": "Is there any kind of business operation?",
    "Profile_LiabilityExposures.describeBusinessOperation": "if yes, describe business",
    "Profile_LiabilityExposures.numberOfDogs": "Number of dogs in the household?",
    "Profile_LiabilityExposures.breedOfDogs": "Breed(s) of dogs",
    "Profile_LiabilityExposures.propertyArea": "Total property area (if greater than 1 acre) in acre",
    "Profile_LiabilityExposures.cannabisPlants": "Number of cannabis plants grown on premises?",
    "Profile_LiabilityExposures.otherExposures": "Other exposures"
}
